import React from 'react'
import {Button, Card, CardBody, CardTitle, CardText} from 'reactstrap'

import PasswordChangeForm from './PasswordChangeForm'

export default class PasswordForm extends React.Component {
  constructor(props){
    super(props)
    this.state = {edit: false}
  }

  toggle = (e) => {
    e.preventDefault();
    this.setState({edit: !this.state.edit})
  }

  render(){
    return(
      <React.Fragment>
        <Card className="m-b-20">
          <CardBody>
            <CardTitle>
              Persönliche Daten{' '}
              <a href="#" onClick={this.toggle} className="float-right">
                {!this.state.edit
                  ?
                  <i className="fas fa-pencil-alt"/>
                  :
                  <i className="fas fa-window-close"/>
                }
              </a>
            </CardTitle>
            <CardText tag="div">
              {!this.state.edit
                ?
                <form>
                  <div className="form-group row">
                    <label
                      className="col-sm-3 col-form-label">
                      Passwort
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="password"
                        name='name'
                        className='form-control-plaintext'
                        defaultValue='********'/>
                    </div>
                  </div>
                </form>
                :
                <React.Fragment>
                  <PasswordChangeForm/>
                </React.Fragment>
              }
            </CardText>
            {this.state.edit &&
              <Button color="secondary" onClick={this.toggle}>Abbrechen</Button>
            }
          </CardBody>
        </Card>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/PasswordForm.js